
import { classes } from 'typestyle'

/* Components =================================================================================== */
import { Box } from '../../../components/box/box.component'

/* Styles ======================================================================================= */
import { mb12 } from '../../../styles/styleset/margin/mb12'
import { p0smi } from '../../../styles/styleset/padding/p0smi'
import { pb32md } from '../../../styles/styleset/padding/pb32md'
import { paddingVerticalOuter } from '../../../styles/default/padding'
import { pt12 } from '../../../styles/styleset/padding/pt12'

export const BodyContent = (props: { children?: any; maxWidth?: any }) => {
  const { children, maxWidth = 960 } = props

  return (
    <Box
      className={classes(paddingVerticalOuter, pb32md)}
      onlyContrast={false}
      baseline="none"
      fullWidth
      relative
      flex
      row
    >
      <Box className={classes(pt12, mb12)} maxWidth={maxWidth} baseline="none" fullWidth centerX>
        <Box baseline="none" className={classes(p0smi)}>
          {children}
        </Box>
      </Box>
    </Box>
  )
}
